import type { EmployerJobActionsProps } from 'features/JobDetails/EmployerJobActions/EmployerJobActions.types';
import clsx from 'clsx';
import Link from 'next/link';
import PostHog from 'components/analytics/PostHog';
import { Button } from 'components/Button';

export const EmployerJobActions = (props: EmployerJobActionsProps) => {
  const { job, className, ...rootProps } = props;

  const gradientBefore =
    "before:content-[''] before:sm:hidden before:absolute before:bottom-full before:left-0 before:right-0 before:h-16 before:bg-gradient-to-t before:from-white before:to-transparent";

  return (
    <div className={clsx(className || 'flex flex-wrap gap-4', gradientBefore)} {...rootProps}>
      <PostHog eventName="Click edit Job" clone={false}>
        <Link href={`/employer/jobs/${job.slug}/edit`}>
          <Button size="lg" fullWidth>
            Edit
          </Button>
        </Link>
      </PostHog>
      <PostHog eventName="Click duplicate Job" clone={false}>
        <Link href={`/employer/jobs/${job.slug}/duplicate`}>
          <Button size="lg" fullWidth>
            Duplicate
          </Button>
        </Link>
      </PostHog>
    </div>
  );
};

EmployerJobActions.displayName = 'EmployerJobActions';
